import type { Tour } from "../types/index";

export const tours: Tour[] = [
  {
    id: 1,
    title: "North Island Explorer",
    region: "north-island",
    duration: 6,
    price: 1200,
    description:
      "Discover the stunning landscapes and rich culture of New Zealand's North Island. From Auckland's vibrant city life to Rotorua's geothermal wonders, this tour showcases the best of the North Island.",
    featuredImage: "/assets/IMG_9188+(2).JPG",
    heroImage: "/assets/auckland-viaduct.jpg",
    itinerary: [
      {
        dayNumber: 1,
        title: "Arrival in Auckland",
        activities: [
          {
            name: "Airport Pickup",
            time: "12:00 PM",
            description:
              "Welcome to New Zealand! Someone from our team will meet you at Auckland Airport and transfer you to your accommodation.",
            duration: "1 hour",
          },
          {
            name: "Check in and Orientation",
            time: "1:00 PM",
            description:
              "A quick orientation of the entire tour itinerary. Explanation of the vehicle and New Zealand road rules.",
            duration: "1 hour",
          },
          {
            name: "Explore Auckland city centre",
            time: "2:00 PM",
            description:
              "Explore Auckland city, stroll along the viaduct harbour and enjoy lunch in the middle of the city.",
            duration: "3 hours",
          },
          {
            name: "Visit Parnell rose garden",
            time: "5:00 PM",
            description:
              "Visit Parnell rose garden and capture photos among the blooms.",
            duration: "1 hour",
          },
          {
            name: "Leisure walk at Mission bay",
            time: "6:00 PM",
            description:
              "Enjoy a leisurely walk at Mission Bay and have a fish and chip dinner by the bay.",
            duration: "2 hours",
          },
        ],
        accommodations: "BK's Pioneer Motel",
      },
      {
        dayNumber: 2,
        title: "Auckland to Rotorua",
        activities: [
          {
            name: "Travel to Matamata (Hobbiton)",
            time: "9:00 AM",
            description: "Scenic drive south to Matamata",
            duration: "2 hours",
          },
          {
            name: "Hobbiton Movie Set",
            time: "11:00 AM",
            description: "Visit the iconic Hobbiton movie set.",
            duration: "3 hours",
          },
          {
            name: "Lunch at Local Restaurant",
            time: "2:00 PM",
            description: "Enjoy lunch at a local restaurant",
            duration: "1 hour",
          },
          {
            name: "Travel to Rotorua and check in to accommodation",
            time: "3:00 PM",
            description: "Drive to Rotorua and check in to your accommodation",
            duration: "1 hour",
          },
          {
            name: "Stroll through Rotorua town center",
            time: "4:00 PM",
            description:
              "Explore the town center of Rotorua, stroll beside the lake and enjoy the views.",
            duration: "2 hours",
          },
        ],
        accommodations: "Sudima Lake Rotorua",
      },
      {
        dayNumber: 3,
        title: "Rotorua day",
        activities: [
          {
            name: "Redwoods Forest Walk",
            time: "9:00 AM",
            description:
              "Morning walk among the giant California Redwood trees in Whakarewarewa Forest.",
            duration: "1 hour",
          },
          {
            name: "Whakarewarewa Maori Village",
            time: "10:00 AM",
            description:
              "Experience an authentic Maori cultural performance and learn about the history of the Maori people.",
            duration: "2 hours",
          },
          {
            name: "Lunch at Local Restaurant",
            time: "12:00 PM",
            description: "Enjoy lunch at a local restaurant",
            duration: "1 hour",
          },
          {
            name: "Skyline Gondola Rotorua",
            time: "1:00 PM",
            description:
              "Experience the stunning views of Rotorua from the Skyline Gondola and luge down the mountain.",
            duration: "3 hours",
          },
        ],
        accommodations: "Sudima Lake Rotorua",
      },
      {
        dayNumber: 4,
        title: "Rotorua to Taupo",
        activities: [
          {
            name: "Travel to Taupo",
            time: "9:00 AM",
            description: "Journey to Taupo, stopping at Huka Falls on the way.",
            duration: "1 hour",
          },
          {
            name: "Walk around at Huka Falls",
            time: "10:00 AM",
            description:
              "Explore the stunning Huka Falls and enjoy the views along the Waikato River.",
            duration: "1 hour",
          },
          {
            name: "Huka Jet Adventure",
            time: "11:00 AM",
            description:
              "Experience the thrilling Huka Jet adventure on at Huka Falls",
            duration: "2 hours",
          },
          {
            name: "Arrival in Taupo",
            time: "2:00 PM",
            description:
              "Check in at the lodge and explore the surroundings of Lake Taupo.",
            duration: "2 hours",
          },
        ],
        accommodations: "Lakefront Lodge Taupo",
      },
      {
        dayNumber: 5,
        title: "Whakapapa Ski Field",
        activities: [
          {
            name: "Drive to Whakapapa Ski Field",
            time: "9:00 AM",
            description: "Scenic drive to Whakapapa Ski Field.",
            duration: "2 hours",
          },
          {
            name: "Ski Field Exploration",
            time: "11:00 AM",
            description:
              "Ride the Sky Waka gondola to the top of the ski field.",
            duration: "1 hour",
          },
          {
            name: "Lunch at ski resort",
            time: "1:00 PM",
            description: "Enjoy a hearty lunch at the ski resort restaurant.",
            duration: "1 hour",
          },
          {
            name: "Skiing/Snowboarding Time",
            time: "2:00 PM",
            description:
              "Free time for skiing or snowboarding at Whakapapa Ski Field.",
            duration: "2 hours",
          },
          {
            name: "Drive back to Taupo",
            time: "4:00 PM",
            description: "Return down the mountain to Taupo via desert road.",
            duration: "3 hours",
          },
        ],
        accommodations: "Lakefront Lodge Taupo",
      },
      {
        dayNumber: 6,
        title: "Return to Auckland",
        activities: [
          {
            name: "Scenic Drive to Auckland",
            time: "10:00 AM",
            description:
              "Scenic drive back to Auckland with stunning views of the countryside.",
            duration: "3 hours",
          },
          {
            name: "Lunch in Auckland",
            time: "1:00 PM",
            description:
              "Enjoy lunch at a local restaurant in Auckland before checking in.",
            duration: "1 hour",
          },
          {
            name: "Check in at BK's Pioneer Motel",
            time: "2:00 PM",
            description: "Check in at BK's Pioneer Motel",
            duration: "1 hour",
          },
          {
            name: "Cornwall Park Visit",
            time: "3:00 PM",
            description:
              "Visit Cornwall Park. A nature reserve with walking trails and scenic views.",
            duration: "2 hours",
          },
          {
            name: "Free Time",
            time: "5:00 PM",
            description: "Relax and explore the surroundings at your leisure.",
            duration: "1 hour",
          },
          {
            name: "Dinner at Local Restaurant",
            time: "7:00 PM",
            description: "Enjoy dinner at a local restaurant",
            duration: "1 hour",
          },
        ],
        accommodations: "BK's Pioneer Motel",
      },
      {
        dayNumber: 7,
        title: "Auckland Day and Departure",
        activities: [
          {
            name: "Check out and visit Westhaven Marina",
            time: "10:00 AM",
            description:
              "Check out from accommodation and visit Westhaven Marina for a scenic stroll and enjoy Auckland's waterfront views.",
            duration: "2 hours",
          },
          {
            name: "Auckland Museum",
            time: "12:00 PM",
            description:
              "Visit Auckland Museum to learn about New Zealand's history and culture.",
            duration: "2 hours",
          },
          {
            name: "Lunch at Local Restaurant",
            time: "12:00 PM",
            description: "Enjoy lunch at a local restaurant",
            duration: "1 hour",
          },
          {
            name: "Free Time",
            time: "1:00 PM",
            description: "Explore any last minute attractions or shopping.",
            duration: "2 hours",
          },
          {
            name: "Departure from New Zealand",
            time: "3:00 PM",
            description:
              "Head to the airport for your departure flight from New Zealand.",
            duration: "1 hour",
          },
        ],
        accommodations: "None",
      },
    ],
  },
  {
    id: 2,
    title: "South Island Adventure",
    region: "south-island",
    duration: 8,
    price: 1900,
    description:
      "Experience the dramatic landscapes of New Zealand's South Island. From Christchurch's charm to Queenstown's adventure capital, this tour highlights the scenic beauty of the South Island.",
    featuredImage: "/assets/queenstown-overview.jpg",
    heroImage: "/assets/hooker-valley-track.jpg",
    itinerary: [
      {
        dayNumber: 1,
        title: "Arrive in Auckland",
        activities: [
          {
            name: "Arrive in Auckland",
            time: "8:00 PM",
            description: "Arrive in Auckland and check in at accommodation.",
            duration: "1.5 hours",
          },
        ],
        accommodations: "BK's Pioneer Motel",
        meals: ["Dinner"],
      },
      {
        dayNumber: 2,
        title: "Auckland to Christchurch",
        activities: [
          {
            name: "Depart from Auckland to Christchurch",
            time: "9:00 AM",
            description: "Depart from Auckland and arrive in Christchurch.",
            duration: "1.5 hours",
          },
          {
            name: "City Exploration",
            time: "11:00 AM",
            description:
              "Explore the city center, Canterbury Museum and lunch.",
            duration: "2 hours",
          },
          {
            name: "Check in at accommodation",
            time: "1:00 PM",
            description: "Check in at accommodation.",
            duration: "1 hour",
          },
          {
            name: "Punting on the Avon River",
            time: "2:00 PM",
            description: "Punt on the Avon River",
            duration: "1 hour",
          },
          {
            name: "Free Time",
            time: "3:00 PM",
            description: "Free and easy time to relax or explore the city.",
            duration: "2 hours",
          },
        ],
        accommodations: "Christchurch Central Hotel",
      },
      {
        dayNumber: 3,
        title: "Lake Tekapo & Twizel",
        activities: [
          {
            name: "Travel to Lake Tekapo",
            time: "8:00 AM",
            description:
              "Scenic drive to the stunning turquoise waters of Lake Tekapo.",
            duration: "3 hours",
          },
          {
            name: "Church of the Good Shepherd",
            time: "11:00 AM",
            description:
              "Visit the iconic stone church and enjoy views of the Southern Alps.",
            duration: "1 hour",
          },
          {
            name: "Tekapo to Twizel",
            time: "1:00 PM",
            description: "Short drive to Twizel.",
            duration: "30 minutes",
          },
          {
            name: "Twizel Exploration",
            time: "2:00 PM",
            description: "Explore Twizel and nearby High Country Salmon farm.",
            duration: "3 hours",
          },
        ],
        accommodations: "Twizel High Country Lodge",
      },
      {
        dayNumber: 4,
        title: "Mount Cook to Wanaka",
        activities: [
          {
            name: "Twizel to Sir Edmund Hillary Centre",
            time: "9:00 AM",
            description:
              "Drive to Mount Cook Village and visit the Sir Edmund Hillary Centre to learn about New Zealand's mountaineering history.",
            duration: "2 hours",
          },
          {
            name: "Mount Cook Valley Walk",
            time: "11:00 AM",
            description:
              "Easy walk to enjoy stunning views of Mount Cook and the surrounding glaciers.",
            duration: "2 hours",
          },
          {
            name: "Scenic Drive to Wanaka",
            time: "2:00 PM",
            description:
              "Journey through the Lindis Pass to the beautiful lakeside town of Wanaka.",
            duration: "2 hours",
          },
          {
            name: "Lake Wanaka Walk",
            time: "4:30 PM",
            description:
              "Lakeside stroll to the famous Wanaka Tree and enjoy dinner with mountain views.",
            duration: "2 hours",
          },
        ],
        accommodations: "Wanaka Lakeside Hotel",
      },
      {
        dayNumber: 5,
        title: "Wanaka to Queenstown",
        activities: [
          {
            name: "Journey to Queenstown",
            time: "9:00 AM",
            description:
              "Drive through the Crown Range to Queenstown, New Zealand's adventure capital.",
            duration: "2 hours",
          },
          {
            name: "Skyline Gondola",
            time: "11:00 AM",
            description:
              "Ride the gondola to Bob's Peak for panoramic views and optional luge rides.",
            duration: "3 hours",
          },
          {
            name: "Check in at accommodation",
            time: "2:00 PM",
            description: "Check in at accommodation.",
            duration: "1 hour",
          },
          {
            name: "Queenstown Gardens",
            time: "4:00 PM",
            description:
              "Relaxing walk through the beautiful lakeside gardens.",
            duration: "1 hour",
          },
        ],
        accommodations: "Garden Court Suites & Apartments",
      },
      {
        dayNumber: 6,
        title: "Queenstown Adventure Day",
        activities: [
          {
            name: "Explore Glenorchy",
            time: "9:00 AM",
            description: "Explore Glenorchy and enjoy lunch.",
            duration: "3 hours",
          },
          {
            name: "Choose Your Adventure",
            time: "2:00 PM",
            description:
              "Options include bungy jumping, jet boating, skydiving, shooting, or canyon swing.",
            duration: "4 hours",
          },
        ],
        accommodations: "Garden Court Suites & Apartments",
      },
      {
        dayNumber: 7,
        title: "To Te Anau and Milford Sound day trip",
        activities: [
          {
            name: "Travel to Te Anau",
            time: "8:00 AM",
            description: "Travel to Te Anau.",
            duration: "2 hours",
          },
          {
            name: "Bus ride to Milford Sound",
            time: "11:00 AM",
            description:
              "Journey through Fiordland National Park with photo stops such as Mirror Lakes and Lupin Viewpoint.",
            duration: "2 hours",
          },
          {
            name: "Milford Sound Cruise",
            time: "1:00 PM",
            description:
              "Nature cruise through the fiord to see waterfalls, seals, and dramatic cliffs.",
            duration: "2 hours",
          },
          {
            name: "Return to Te Anau",
            time: "3:00 PM",
            description: "Return to Te Anau and check in at accommodation.",
            duration: "2 hours",
          },
          {
            name: "Free Time",
            time: "5:00 PM",
            description:
              "Free time to relax or explore the picturesque town of Te Anau.",
            duration: "2 hours",
          },
        ],
        accommodations: "Te Anau Lakeside Hotel",
      },
      {
        dayNumber: 8,
        title: "Return to Queenstown",
        activities: [
          {
            name: "Te Anau to Queenstown",
            time: "9:00 AM",
            description:
              "Morning drive back to Queenstown with stops at scenic viewpoints.",
            duration: "2 hours",
          },
          {
            name: "Glenorchy Day Trip",
            time: "11:00 AM",
            description:
              "Scenic drive to Glenorchy, location for many Lord of the Rings scenes.",
            duration: "4 hours",
          },
          {
            name: "Free Time in Queenstown",
            time: "4:00 PM",
            description: "Time for last minute shopping or relaxation.",
            duration: "2 hours",
          },
        ],
        accommodations: "Garden Court Suites & Apartments",
      },
      {
        dayNumber: 9,
        title: "Queenstown to Auckland and Departure",
        activities: [
          {
            name: "Check out of accommodation",
            time: "10:00 AM",
            description: "Check out of accommodation.",
            duration: "15 minutes",
          },
          {
            name: "Breakfast and Airport Transfer",
            time: "10:15 AM",
            description: "Transfer to Queenstown Airport.",
            duration: "2 hours",
          },
          {
            name: "Afternoon Flight",
            time: "1:00 PM",
            description: "Fly from Queenstown to Auckland.",
            duration: "2 hours",
          },
          {
            name: "Farewell Lunch",
            time: "4:00 PM",
            description:
              "Group farewell lunch in Auckland's vibrant city center.",
            duration: "2 hours",
          },
          {
            name: "Airport Transfer",
            time: "Flexible",
            description:
              "Transfer to Auckland Airport for your departure flight.",
            duration: "1 hour",
          },
        ],
      },
    ],
  },
  {
    id: 3,
    title: "Combo Island Experience",
    region: "combo-island",
    duration: 10,
    price: 2500,
    description:
      "The complete New Zealand experience combining the best of both islands. From Auckland City to Milford Sound, this comprehensive tour showcases the country's incredible diversity of landscapes, culture and experiences.",
    featuredImage: "/assets/helicopter.jpg",
    heroImage: "/assets/lake-pukaki-aoraki-road.jpg",
    itinerary: [
      // North Island portion (Days 1-7)
      {
        dayNumber: 1,
        title: "Arrival in Auckland",
        activities: [
          {
            name: "Airport Pickup",
            time: "7:00 PM",
            description:
              "Welcome to New Zealand! Someone from our team will meet you at Auckland Airport and transfer you to your hotel.",
            duration: "1 hour",
          },
          {
            name: "Orientation",
            time: "8:00 PM",
            description:
              "A quick orientation of the entire tour itinerary. Explanation of the vehicle and New Zealand road rules.",
            duration: "1 hour",
          },
        ],
        accommodations: "BK's Pioneer Motel",
      },
      {
        dayNumber: 2,
        title: "Auckland to Rotorua",
        activities: [
          {
            name: "Travel to Matamata (Hobbiton)",
            time: "9:00 AM",
            description: "Scenic drive south to Matamata",
            duration: "2 hours",
          },
          {
            name: "Hobbiton Movie Set",
            time: "11:00 AM",
            description: "Visit the iconic Hobbiton movie set.",
            duration: "3 hours",
          },
          {
            name: "Lunch at Local Restaurant",
            time: "2:00 PM",
            description: "Enjoy lunch at a local restaurant",
            duration: "1 hour",
          },
          {
            name: "Travel to Rotorua and check in to accommodation",
            time: "3:00 PM",
            description: "Drive to Rotorua and check in to your accommodation",
            duration: "1 hour",
          },
          {
            name: "Stroll through Rotorua town center",
            time: "4:00 PM",
            description:
              "Explore the town center of Rotorua, stroll beside the lake and enjoy the views.",
            duration: "2 hours",
          },
        ],
        accommodations: "Sudima Lake Rotorua",
      },
      {
        dayNumber: 3,
        title: "Rotorua day",
        activities: [
          {
            name: "Redwoods Forest Walk",
            time: "9:00 AM",
            description:
              "Morning walk among the giant California Redwood trees in Whakarewarewa Forest.",
            duration: "1 hour",
          },
          {
            name: "Whakarewarewa Maori Village",
            time: "10:00 AM",
            description:
              "Experience an authentic Maori cultural performance and learn about the history of the Maori people.",
            duration: "2 hours",
          },
          {
            name: "Lunch at Local Restaurant",
            time: "12:00 PM",
            description: "Enjoy lunch at a local restaurant",
            duration: "1 hour",
          },
          {
            name: "Skyline Gondola Rotorua",
            time: "1:00 PM",
            description:
              "Experience the stunning views of Rotorua from the Skyline Gondola and luge down the mountain.",
            duration: "3 hours",
          },
        ],
        accommodations: "Sudima Lake Rotorua",
      },
      {
        dayNumber: 4,
        title: "Rotorua to Taupo",
        activities: [
          {
            name: "Travel to Taupo",
            time: "9:00 AM",
            description: "Journey to Taupo, stopping at Huka Falls on the way.",
            duration: "1 hour",
          },
          {
            name: "Walk around at Huka Falls",
            time: "10:00 AM",
            description:
              "Explore the stunning Huka Falls and enjoy the views along the Waikato River.",
            duration: "1 hour",
          },
          {
            name: "Huka Jet Adventure",
            time: "11:00 AM",
            description:
              "Experience the thrilling Huka Jet adventure on at Huka Falls",
            duration: "2 hours",
          },
          {
            name: "Arrival in Taupo",
            time: "2:00 PM",
            description:
              "Check in at the lodge and explore the surroundings of Lake Taupo.",
            duration: "2 hours",
          },
        ],
        accommodations: "Lakefront Lodge Taupo",
      },
      {
        dayNumber: 5,
        title: "Whakapapa Ski Field",
        activities: [
          {
            name: "Drive to Whakapapa Ski Field",
            time: "9:00 AM",
            description: "Scenic drive to Whakapapa Ski Field.",
            duration: "2 hours",
          },
          {
            name: "Ski Field Exploration",
            time: "11:00 AM",
            description:
              "Ride the Sky Waka gondola to the top of the ski field.",
            duration: "1 hour",
          },
          {
            name: "Lunch at ski resort",
            time: "1:00 PM",
            description: "Enjoy a hearty lunch at the ski resort restaurant.",
            duration: "1 hour",
          },
          {
            name: "Skiing/Snowboarding Time",
            time: "2:00 PM",
            description:
              "Free time for skiing or snowboarding at Whakapapa Ski Field.",
            duration: "2 hours",
          },
          {
            name: "Drive back to Taupo",
            time: "4:00 PM",
            description: "Return down the mountain to Taupo via desert road.",
            duration: "3 hours",
          },
        ],
        accommodations: "Lakefront Lodge Taupo",
      },
      {
        dayNumber: 6,
        title: "Return to Auckland",
        activities: [
          {
            name: "Scenic Drive to Auckland",
            time: "10:00 AM",
            description:
              "Scenic drive back to Auckland with stunning views of the countryside.",
            duration: "3 hours",
          },
          {
            name: "Lunch in Auckland",
            time: "1:00 PM",
            description:
              "Enjoy lunch at a local restaurant in Auckland before checking in.",
            duration: "1 hour",
          },
          {
            name: "Free Time",
            time: "2:00 PM",
            description:
              "Free time to explore Auckland or rest before the South Island portion.",
            duration: "3 hours",
          },
        ],
        accommodations: "BK's Pioneer Motel",
      },
      {
        dayNumber: 7,
        title: "Fly to Christchurch",
        activities: [
          {
            name: "Flight to Christchurch",
            time: "9:00 AM",
            description:
              "Fly from Auckland to Christchurch to begin South Island adventure.",
            duration: "1.5 hours",
          },
          {
            name: "Christchurch Arrival",
            time: "11:00 AM",
            description:
              "Meet your guide at Christchurch Airport and transfer to your accommodation.",
            duration: "1 hour",
          },
          {
            name: "City Exploration",
            time: "1:00 PM",
            description:
              "Explore the city center, Canterbury Museum and lunch.",
            duration: "2 hours",
          },
          {
            name: "Punting on the Avon River",
            time: "3:00 PM",
            description: "Punt on the Avon River",
            duration: "1 hour",
          },
        ],
        accommodations: "Christchurch Central Hotel",
      },
      // South Island portion (Days 8-16) - using the updated South Island itinerary
      {
        dayNumber: 8,
        title: "Lake Tekapo & Twizel",
        activities: [
          {
            name: "Travel to Lake Tekapo",
            time: "8:00 AM",
            description:
              "Scenic drive to the stunning turquoise waters of Lake Tekapo.",
            duration: "3 hours",
          },
          {
            name: "Church of the Good Shepherd",
            time: "11:00 AM",
            description:
              "Visit the iconic stone church and enjoy views of the Southern Alps.",
            duration: "1 hour",
          },
          {
            name: "Tekapo to Twizel",
            time: "1:00 PM",
            description: "Short drive to Twizel.",
            duration: "30 minutes",
          },
          {
            name: "Twizel Exploration",
            time: "2:00 PM",
            description: "Explore Twizel and nearby High Country Salmon farm.",
            duration: "3 hours",
          },
        ],
        accommodations: "Twizel High Country Lodge",
      },
      {
        dayNumber: 9,
        title: "Mount Cook to Wanaka",
        activities: [
          {
            name: "Twizel to Sir Edmund Hillary Centre",
            time: "9:00 AM",
            description:
              "Drive to Mount Cook Village and visit the Sir Edmund Hillary Centre to learn about New Zealand's mountaineering history.",
            duration: "2 hours",
          },
          {
            name: "Mount Cook Valley Walk",
            time: "11:00 AM",
            description:
              "Easy walk to enjoy stunning views of Mount Cook and the surrounding glaciers.",
            duration: "2 hours",
          },
          {
            name: "Scenic Drive to Wanaka",
            time: "2:00 PM",
            description:
              "Journey through the Lindis Pass to the beautiful lakeside town of Wanaka.",
            duration: "2 hours",
          },
          {
            name: "Lake Wanaka Walk",
            time: "4:30 PM",
            description:
              "Lakeside stroll to the famous Wanaka Tree and enjoy dinner with mountain views.",
            duration: "2 hours",
          },
        ],
        accommodations: "Wanaka Lakeside Hotel",
      },
      {
        dayNumber: 10,
        title: "Wanaka to Queenstown",
        activities: [
          {
            name: "Journey to Queenstown",
            time: "9:00 AM",
            description:
              "Drive through the Crown Range to Queenstown, New Zealand's adventure capital.",
            duration: "2 hours",
          },
          {
            name: "Skyline Gondola",
            time: "11:00 AM",
            description:
              "Ride the gondola to Bob's Peak for panoramic views and optional luge rides.",
            duration: "3 hours",
          },
          {
            name: "Check in at accommodation",
            time: "2:00 PM",
            description: "Check in at accommodation.",
            duration: "1 hour",
          },
          {
            name: "Queenstown Gardens",
            time: "4:00 PM",
            description:
              "Relaxing walk through the beautiful lakeside gardens.",
            duration: "1 hour",
          },
        ],
        accommodations: "Garden Court Suites & Apartments",
      },
      {
        dayNumber: 11,
        title: "Queenstown Adventure Day",
        activities: [
          {
            name: "Explore Glenorchy",
            time: "9:00 AM",
            description: "Explore Glenorchy and enjoy lunch.",
            duration: "3 hours",
          },
          {
            name: "Choose Your Adventure",
            time: "2:00 PM",
            description:
              "Options include bungy jumping, jet boating, skydiving, shooting, or canyon swing.",
            duration: "4 hours",
          },
        ],
        accommodations: "Garden Court Suites & Apartments",
      },
      {
        dayNumber: 12,
        title: "To Te Anau and Milford Sound day trip",
        activities: [
          {
            name: "Travel to Te Anau",
            time: "8:00 AM",
            description: "Travel to Te Anau.",
            duration: "2 hours",
          },
          {
            name: "Bus ride to Milford Sound",
            time: "11:00 AM",
            description:
              "Journey through Fiordland National Park with photo stops such as Mirror Lakes and Lupin Viewpoint.",
            duration: "2 hours",
          },
          {
            name: "Milford Sound Cruise",
            time: "1:00 PM",
            description:
              "Nature cruise through the fiord to see waterfalls, seals, and dramatic cliffs.",
            duration: "2 hours",
          },
          {
            name: "Return to Te Anau",
            time: "3:00 PM",
            description: "Return to Te Anau and check in at accommodation.",
            duration: "2 hours",
          },
          {
            name: "Free Time",
            time: "5:00 PM",
            description:
              "Free time to relax or explore the picturesque town of Te Anau.",
            duration: "2 hours",
          },
        ],
        accommodations: "Te Anau Lakeside Hotel",
      },
      {
        dayNumber: 13,
        title: "Return to Queenstown",
        activities: [
          {
            name: "Te Anau to Queenstown",
            time: "9:00 AM",
            description:
              "Morning drive back to Queenstown with stops at scenic viewpoints.",
            duration: "2 hours",
          },
          {
            name: "Free Time in Queenstown",
            time: "11:00 AM",
            description: "Time for last minute shopping or relaxation.",
            duration: "2 hours",
          },
          {
            name: "Farewell Lunch",
            time: "1:00 PM",
            description: "Group farewell lunch in Queenstown.",
            duration: "2 hours",
          },
        ],
        accommodations: "Garden Court Suites & Apartments",
      },
      {
        dayNumber: 14,
        title: "Queenstown to Auckland",
        activities: [
          {
            name: "Check out of accommodation",
            time: "10:00 AM",
            description: "Check out of accommodation.",
            duration: "15 minutes",
          },
          {
            name: "Breakfast and Airport Transfer",
            time: "10:15 AM",
            description: "Transfer to Queenstown Airport.",
            duration: "2 hours",
          },
          {
            name: "Afternoon Flight",
            time: "1:00 PM",
            description: "Fly from Queenstown to Auckland.",
            duration: "2 hours",
          },
          {
            name: "Auckland Farewell Dinner",
            time: "6:00 PM",
            description: "Farewell dinner in Auckland's vibrant city center.",
            duration: "2 hours",
          },
        ],
        accommodations: "Auckland Sky Hotel",
      },
      {
        dayNumber: 15,
        title: "Free Day in Auckland",
        activities: [
          {
            name: "Free Exploration",
            time: "9:00 AM",
            description:
              "Free time to explore Auckland's attractions, shopping, or relax.",
            duration: "6 hours",
          },
          {
            name: "Farewell Dinner",
            time: "7:00 PM",
            description: "Final farewell dinner with the group.",
            duration: "2 hours",
          },
        ],
        accommodations: "Auckland Sky Hotel",
      },
      {
        dayNumber: 16,
        title: "Departure",
        activities: [
          {
            name: "Airport Transfer",
            time: "Flexible",
            description:
              "Transfer to Auckland Airport for your departure flight.",
            duration: "1 hour",
          },
        ],
        accommodations: "None",
      },
    ],
  },
];
